import { render, staticRenderFns } from "./DashboardWidgetTitle.vue?vue&type=template&id=7e815244&scoped=true&"
import script from "./DashboardWidgetTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetTitle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetTitle.vue?vue&type=style&index=0&id=7e815244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e815244",
  null
  
)

export default component.exports